import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import StockorderDashboard from '../StockorderDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';
import StockorderPageImpl from './StockorderPageImpl';

export default function StockorderPage() {
    const {mobileView} = useSelector((state)=>state.menu);
    const dispatch = useDispatch();
    const { stockorderList} = useSelector((state)=>state.manufslice)
    useEffect(() => {
        dispatch(openDrawer({'drawerOpen':!mobileView}));
    },[]);

    return (
        < StockorderPageImpl />
    )

}